import React from 'react'
import AnnouncementHeadline from 'app/gears/announcements/components/AnnouncementHeadline'
import 'app/gears/announcements/style/announcements.scss'

// Display fewer announcements in mini-gear mode since we have less screen real estate
const MAX_TO_DISPLAY_MIN_MODE = 3
const MAX_TO_DISPLAY_MAX_MODE = 25

/**
 * Display a list of announcements so that the user can choose to view one
 * 
 * @param {Array} announcements the announcements to display
 * @param {boolean} minMode whether this is rendered in a mini-gear where space is at a premium
 * @param {number} [maxAnnouncementsToDisplay] the maximum number of announcements to display, if less than default
 * @author Alex Clary
 * @since 20.4.5
 * @prettier
 */
const Announcements = ({ announcements, minMode, maxAnnouncementsToDisplay }) => <div>
  <h3>Announcements</h3>
  {announcements.length === 0 && <span>No active announcements.</span>}
  <ol className='announcements-list'>
    {announcements.sort((a, b) => b.beginDate - a.beginDate)
      // Display fewer announcements in mini-gear mode since we have less screen real estate
      .slice(0, minMode ? MAX_TO_DISPLAY_MIN_MODE : MAX_TO_DISPLAY_MAX_MODE )
      // Allow an additional manual override of items to display, e.g. for the front landing page
      .slice(0, maxAnnouncementsToDisplay ? parseInt(maxAnnouncementsToDisplay) : MAX_TO_DISPLAY_MAX_MODE)
      // Display a headline of each announcement rather than the full text
      .map(announcement => <li key={announcement.id}><AnnouncementHeadline announcement={announcement} /></li>)}
  </ol>
</div>


export default Announcements


